import * as actionTypes from '../types/undercut';
// GET_UNDERCUT_LIST
// GET_UNDERCUT_TYPES_LIST
// GET_UNDERCUT_OPERATION
// SAVE_UNDERCUT
// DELETE_UNDERCUT
const initialState = {
  undercutList: [],
  undercutTypesList: [],
  undercutOperation: null,
  undercutConfirmList: [],
  undercutGet: {
    okRequest: false,
    loading: false
  },
  undercutTypesListGet: {
    okRequest: false,
    loading: false
  },
  undercutOperationGet: {
    okRequest: false,
    loading: false
  },
  undercutSave: {
    okRequest: false,
    loading: false
  },
  undercutDelete: {
    okRequest: false,
    loading: false
  },
  undercutConfirmListGet: {
    okRequest: false,
    loading: false
  },
  undercutStorno: {
    okRequest: false,
    loading: false
  },
  undercutConfirm: {
    okRequest: false,
    loading: false
  }
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_UNDERCUT_LIST:
      return {
        ...state,
        undercutGet: {
          okRequest: false,
          loading: true
        }
      };

    case actionTypes.GET_UNDERCUT_LIST_SUCCESS:
      return {
        ...state,
        undercutList: payload,
        undercutGet: {
          okRequest: true,
          loading: false
        }
      };

    case actionTypes.GET_UNDERCUT_LIST_FAIL:
      return {
        ...state,
        undercutGet: {
          okRequest: false,
          loading: false
        }
      };

    case actionTypes.GET_UNDERCUT_CONFIRM_LIST:
      return {
        ...state,
        undercutConfirmListGet: {
          okRequest: false,
          loading: true
        }
      };

    case actionTypes.GET_UNDERCUT_CONFIRM_LIST_SUCCESS:
      return {
        ...state,
        undercutConfirmList: payload.map((el) => ({
          ...el.semiProduct,
          cuttingPieceNumId: el.cuttingProduct.pieceNumId,
          cuttingQcId: el.cuttingProduct.qcId,
          cuttingAccountingDate: el.cuttingProduct.accountingDate,
          cuttingPsStatusName: el.cuttingProduct.psStatusName,
          cuttingPsStatusNumId: el.cuttingProduct.psStatusNumId,
          cuttingCgId: el.cuttingProduct.cgId,
          cuttingActualPieceId: el.cuttingProduct.actualPieceId,
          cuttingQuantity: el.cuttingProduct.quantity,
          cuttingWeightBrutto: el.cuttingProduct.weightBrutto,
          cuttingWeightRemain: el.cuttingProduct.weightRemain,
          cuttingWeightTrim: el.cuttingProduct.weightTrim,
          cuttingWeightWaste: el.cuttingProduct.weightWaste,
          cuttingWeightEndProduct: el.cuttingProduct.weightEndProduct,
          cuttingIncomingDate: el.cuttingProduct.incomingDate,
          cuttingBatchId: el.cuttingProduct.batchId,
          cuttingCheckbox: el.cuttingProduct.checkbox,
          cuttingZdvlOrderNumId: el.cuttingProduct.zdvlOrderNumId,
          cuttingZdvlOrderLineId: el.cuttingProduct.zdvlOrderLineId,
          cuttingZdvlLineId: el.cuttingProduct.zdvlLineId,
          cuttingWeightOff: el.cuttingProduct.weightOff,
          // eslint-disable-next-line no-restricted-globals
          cuttingPercentWasteMaterial: isNaN(el.cuttingProduct.percentWasteMaterial)
            ? 0
            : el.cuttingProduct.percentWasteMaterial,
          cuttingSkuCoilId: el.cuttingProduct.skuCoilId,
          cuttingThick: el.cuttingProduct.thick,
          cuttingWidth: el.cuttingProduct.width,
          cuttingReadyProfileSize: el.cuttingProduct.readyProfileSize,
          cuttingReadyLength: el.cuttingProduct.readyLength,
          cuttingMark: el.cuttingProduct.mark,
          cuttingWeightTrimOff: el.cuttingProduct.weightTrimOff,
          cuttingWeightWasteOff: el.cuttingProduct.weightWasteOff,
          cuttingWeightSumOff: el.cuttingProduct.weightSumOff,
          cuttingTaskNumId: el.cuttingProduct.taskNumId,
          cuttingTaskNumber: el.cuttingProduct.taskNumber,
          cuttingTaskDate: el.cuttingProduct.taskDate,
          // eslint-disable-next-line no-restricted-globals,max-len
          percentWasteMaterial: isNaN(el.semiProduct.percentWasteMaterial) ? 0 : el.semiProduct.percentWasteMaterial,
          finishedProductId: `${el.cuttingProduct.pieceNumId}${el.semiProduct.pieceNumId}`
        })),
        //   {
        //     "pieceNumId": 9242,
        //     "qcId": "1420290202",
        //     "accountingDate": "2022-11-26",
        //     "psStatusName": "Создан",
        //     "psStatusNumId": 1,
        //     "cgId": "1395",
        //     "actualPieceId": "4422",
        //     "weightNetto": 0.9,
        //     "weightBrutto": 0.91,
        //     "weightRemain": 0,
        //     "weightTrim": null,
        //     "weightWaste": null,
        //     "weightEndProduct": null,
        //     "incomingDate": "2022-12-06",
        //     "batchId": "0229376026",
        //     "checkbox": "NOT_SELECTED",
        //     "zdvlOrderNumId": null,
        //     "zdvlOrderLineId": null,
        //     "zdvlLineId": null,
        //     "weightOff": null,
        //     "percentWasteMaterial": null,
        //     "skuCoilId": "SKUFTO000000000004",
        //     "thick": 2.8,
        //     "width": 59,
        //     "cuttingProfileSize": null,
        //     "cuttingLength": null,
        //     "mark": null,
        //     "weightTrimOff": null,
        //     "weightWasteOff": null,
        //     "weightSumOff": null,
        //     "taskNumId": null,
        //     "taskNumber": null,
        //     "taskDate": null
        // }
        undercutConfirmListGet: {
          okRequest: true,
          loading: false
        }
      };

    case actionTypes.GET_UNDERCUT_CONFIRM_LIST_FAIL:
      return {
        ...state,
        undercutConfirmListGet: {
          okRequest: false,
          loading: false
        }
      };

    case actionTypes.GET_UNDERCUT_OPERATION:
      return {
        ...state,
        undercutOperation: null,
        undercutOperationGet: {
          okRequest: false,
          loading: true
        }
      };

    case actionTypes.GET_UNDERCUT_OPERATION_SUCCESS:
      return {
        ...state,
        undercutOperation: payload,
        undercutOperationGet: {
          okRequest: true,
          loading: false
        }
      };

    case actionTypes.GET_UNDERCUT_OPERATION_FAIL:
      return {
        ...state,
        undercutOperationGet: {
          okRequest: false,
          loading: false
        }
      };

    case actionTypes.GET_UNDERCUT_TYPES_LIST:
      return {
        ...state,
        undercutTypesListGet: {
          okRequest: false,
          loading: true
        }
      };

    case actionTypes.GET_UNDERCUT_TYPES_LIST_SUCCESS:
      return {
        ...state,
        undercutTypesList: payload,
        undercutTypesListGet: {
          okRequest: true,
          loading: false
        }
      };

    case actionTypes.GET_UNDERCUT_TYPES_LIST_FAIL:
      return {
        ...state,
        undercutTypesListGet: {
          okRequest: false,
          loading: false
        }
      };

    case actionTypes.SAVE_UNDERCUT:
      return {
        ...state,
        undercutSave: {
          okRequest: false,
          loading: true
        }
      };

    case actionTypes.SAVE_UNDERCUT_SUCCESS:
      return {
        ...state,
        undercutSave: {
          okRequest: true,
          loading: false
        }
      };

    case actionTypes.SAVE_UNDERCUT_FAIL:
      return {
        ...state,
        undercutSave: {
          okRequest: false,
          loading: false
        }
      };

    case actionTypes.DELETE_UNDERCUT:
      return {
        ...state,
        undercutDelete: {
          okRequest: false,
          loading: true
        }
      };

    case actionTypes.DELETE_UNDERCUT_SUCCESS:
      return {
        ...state,
        undercutDelete: {
          okRequest: true,
          loading: false
        }
      };

    case actionTypes.DELETE_UNDERCUT_FAIL:
      return {
        ...state,
        undercutDelete: {
          okRequest: false,
          loading: false
        }
      };

    case actionTypes.CONFIRM_UNDERCUT:
      return {
        ...state,
        undercutConfirm: {
          okRequest: false,
          loading: true
        }
      };

    case actionTypes.CONFIRM_UNDERCUT_SUCCESS:
      return {
        ...state,
        undercutConfirm: {
          okRequest: true,
          loading: false
        }
      };

    case actionTypes.CONFIRM_UNDERCUT_FAIL:
      return {
        ...state,
        undercutConfirm: {
          okRequest: false,
          loading: false
        }
      };

    case actionTypes.STORNO_UNDERCUT:
      return {
        ...state,
        undercutStorno: {
          okRequest: false,
          loading: true
        }
      };

    case actionTypes.STORNO_UNDERCUT_SUCCESS:
      return {
        ...state,
        undercutStorno: {
          okRequest: true,
          loading: false
        }
      };

    case actionTypes.STORNO_UNDERCUT_FAIL:
      return {
        ...state,
        undercutStorno: {
          okRequest: false,
          loading: false
        }
      };

    default:
      return state;
  }
};

export default reducer;
